import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSnackBarComponent } from '../mat-snack-bar/mat-snack-bar.component';
import { PagerService } from 'src/app/Services/pager.service';
import { DatePipe } from '@angular/common';
import { Documents } from 'src/app/Models/AnnualRequirement/ExcelDocuments';
import { ArtworksSpecificationService } from 'src/app/Services/admin-rights/artworks-specification.service';
import { Artworkspecification, DropDown } from 'src/app/Models/Admin/artworkspecification';
import { Router } from '@angular/router';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-artworks-specification',
  templateUrl: './artworks-specification.component.html',
  styleUrls: ['./artworks-specification.component.css'],
  providers: [DatePipe]
})
export class ArtworksSpecificationComponent implements OnInit {
  artworkDetails: any;
  rowCount: any;
  model: any;
  selectedState: string;
  selectedMA: string;
  otherBrands: string = 'false';
  loader: string = 'none';
  pageSetting: number = 10;
  modalSetting: number = 0;
  pager: any = {};
  modelDepandent: any[];
  files: File[] = [];
  fileName: string = '';
  displayAddJob: string = 'none';
  displayEditArtwork: string = 'none';
  popupHeader : string = '';
  displayOtherBrand: string = 'none';
  document: Documents = new Documents();
  fileToUpload: File = null;
  IsFileCorrect: boolean;
  customID: number = 0;
  customBrand: string = '';
  customCrop: string = '';
  customJob: string = '';
  customLanguage: string = '';
  customSpecification: string = '';
  customRemarks: string = ''
  customOpenSize: string = '';
  customFinishSize: string = '';
  customNoPages: string = '';
  customColor: string = '';
  customFabrication: string = '';
  customPrinting: string = '';
  customActive: boolean = true;
  customPortFolio: string = 'Insecticide common'
  customOtherBrand: string = '';
  customOtherBrandId: string = '';
  customBrandManager: string = '';
  customItemName: string = '';
  AddJobdropdown: DropDown = new DropDown();
  @ViewChild('file') input;
  disabledOptions : boolean = false;
  currentYear:number;
  unitPriceCurrent:number=0;
  unitPriceFuture:number=0;

  displayEditPanel:string='none';
  unitPriceCurrentQ1:number=0;
  unitPriceCurrentQ2:number=0; 
  unitPriceCurrentQ3:number=0;
  unitPriceCurrentQ4:number=0;
  unitPriceFutureQ1:number=0;
  unitPriceFutureQ2:number=0;
  unitPriceFutureQ3:number=0;
  unitPriceFutureQ4:number=0;
  constructor(private artworksSpecificationService: ArtworksSpecificationService, private snackBar: MatSnackBarComponent, private _pagerService: PagerService,
    private router: Router, private datepipe: DatePipe,private toastr: ToastrService) { }

  ngOnInit() {
    if (sessionStorage.tabID == undefined) {
      this.router.navigate(['/MCMaterial/Login']);
    }
    this.getArtworksSpecification();
    this.getArtworksSpecificationDropDown();
    this.currentYear = new Date().getFullYear();
  }

  async getArtworksSpecification() {
    this.loader = 'block';
    await this.artworksSpecificationService.GetArtworksSpecification()
      .subscribe((resdata: any) => {
        if (resdata.status == true) {
          this.artworkDetails = resdata.data.artworkDetails;
          this.model = resdata.data.artworkDetails;
          this.rowCount = resdata.data.rowCount;
          this.setPage(1, this.pageSetting)
          this.loader = 'none';
          // console.log('art'+resdata.data.artworkDetails);
        }
        else {
          this.toastr.error(resdata.msg);
          this.loader = 'none';
        }
      })
  }
  onChange(val) {
    if (val == "Others") {
      this.displayOtherBrand = 'block';
      this.popupHeader = 'Add Other Brands'
      this.disabledOptions = true;
    }
    this.customOtherBrand = '';
    this.customBrandManager = '';
  }
  // Start :For Pagination
  setPage(page: number, pageSize: number) {
    // get pager object from service
    if (this.modalSetting == 0) {
      this.pager = this._pagerService.getPager(this.model.length, page, pageSize);
      this.artworkDetails = this.model.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
    else {
      if (this.modalSetting == 1) {
        this.pager = this._pagerService.getPager(this.model.length, page, pageSize);
        this.artworkDetails = this.model.slice(this.pager.startIndex, this.pager.endIndex + 1);
      }
      else {
        this.pager = this._pagerService.getPager(this.modelDepandent.length, page, pageSize);
        this.artworkDetails = this.modelDepandent.slice(this.pager.startIndex, this.pager.endIndex + 1);
      }
    }
    // get current page of items
  }

  excelDownload() {
    this.loader = 'block';
    this.artworksSpecificationService.downloadArtworkExcel()
      .subscribe(
        success => {
          var date = new Date();
          let latest_date = this.datepipe.transform(date, 'dd-MMM-yy')
          let Name = localStorage.getItem('mcmt_userName').split(' ');
          let Firstname = Name[0];
          let LastName = Name[1];
          let ExcelName = Firstname + '_' + LastName + '_ArtworkSpecification_' + latest_date + '.xlsx';
          saveAs(success, ExcelName);

          this.loader = 'none';
        },
        err => {
          this.toastr.error("No record/s available");
          this.loader = 'none';
        }
      );
  }



  filesDroppedAdd(files: File[]) {

    this.files = [];
    this.files = files;
    let fileNameParts: string[] = files[0].name.split('.');
    let fileType = files[0].name.split('.')[fileNameParts.length - 1];
    let Name = localStorage.getItem('mcmt_userName').split(' ');
    let Firstname = Name[0];
    let LastName = Name[1];
    let CorrectFileName = Firstname + '_' + LastName + '_ArtworkSpecification_'
    if (fileNameParts[0].includes(CorrectFileName)) {
      this.IsFileCorrect = true;
    }
    else {
      this.IsFileCorrect = false;
    }
    if (fileType != 'xls' && fileType != 'xlsx') {
      this.toastr.error('Please Select Valid File Type.');
      //this.toastr.error('Please Select Valid File Type.', 'Close', 'red-snackbar');
      this.loader = 'none';
      this.input.nativeElement.value = null;
      return false;
    }

    this.loader = 'block';
    this.document.file = <File>this.files[0];
    this.artworksSpecificationService.uploadDocument(this.document.file)
      .subscribe((resData: any) => {
        if (resData.status == true) {
          this.toastr.success(resData.message);
          //this.toastr.error(resData.message, 'Close', 'green-snackbar');
          this.getArtworksSpecification();
          this.loader = 'none';
          this.input.nativeElement.value = null;
        } else {
          this.toastr.error(resData.message);
          //this.toastr.error(resData.message, 'Close', 'red-snackbar');
          this.loader = 'none';
          this.getArtworksSpecification();
          this.input.nativeElement.value = null;
        }
        this.files = [];
        this.loader = 'none';
      });
    this.files = files;
    this.fileName = files[0].name;
  }

  addJob() {
    this.displayEditArtwork = 'block';
    this.popupHeader = 'Add Job Items'
    this.unitPriceCurrentQ1 = 0;
    this.unitPriceCurrentQ2=0;
    this.unitPriceCurrentQ3=0;
    this.unitPriceCurrentQ4=0;

    this.unitPriceFutureQ1=0;
    this.unitPriceFutureQ2=0;
    this.unitPriceFutureQ3=0;
    this.unitPriceFutureQ4=0;

    this.unitPriceFuture = 0;
  }

  editArtwork(index: any) {
    this.popupHeader = 'Update Artwork Specification';
    this.displayEditArtwork = 'block';
    this.customID = this.artworkDetails[index].id;
    this.customActive = this.artworkDetails[index].active;
    this.customBrand = this.artworkDetails[index].brand;
    this.customColor = this.artworkDetails[index].color;
    this.customCrop = this.artworkDetails[index].crop;
    this.customFabrication = this.artworkDetails[index].fabrication;
    this.customFinishSize = this.artworkDetails[index].finishSize;
    this.customJob = this.artworkDetails[index].job;
    this.customLanguage = this.artworkDetails[index].languagae;
    this.customNoPages = this.artworkDetails[index].noOfPage;
    this.customOpenSize = this.artworkDetails[index].openSize;
    this.customPrinting = this.artworkDetails[index].printingProcess;
    this.customSpecification = this.artworkDetails[index].specification;
    this.customRemarks = this.artworkDetails[index].remarks;
    this.unitPriceCurrentQ1=this.artworkDetails[index].unitPriceCQ1;
    this.unitPriceCurrentQ2=this.artworkDetails[index].unitPriceCQ2;
    this.unitPriceCurrentQ3=this.artworkDetails[index].unitPriceCQ3;
    this.unitPriceCurrentQ4=this.artworkDetails[index].unitPriceCQ4;

    this.unitPriceFutureQ1=this.artworkDetails[index].unitPriceFQ1;
    this.unitPriceFutureQ2=this.artworkDetails[index].unitPriceFQ2;
    this.unitPriceFutureQ3=this.artworkDetails[index].unitPriceFQ3;
    this.unitPriceFutureQ4=this.artworkDetails[index].unitPriceFQ4;
    
  }
  closeArtwork() {
    this.displayEditArtwork = 'none';
    this.displayOtherBrand = 'none';
    this.customID = 0;
    this.customBrand = '';
    this.customColor = '';
    this.customCrop = '';
    this.customFabrication = '';
    this.customFinishSize = '';
    this.customJob = '';
    this.customLanguage = '';
    this.customNoPages = '';
    this.customOpenSize = '';
    this.customPrinting = '';
    this.customSpecification = '';
    this.customRemarks = '';
    this.displayEditPanel='none';
  }

  addArtwork() {
    this.loader = 'block';
    this.displayEditPanel='none';
    var updatebrand
    if (this.customBrand == 'Others') {
      updatebrand = this.customOtherBrand
    }
    else {
      updatebrand = this.customBrand
    }
    if (updatebrand != '') {
      if (this.customCrop != '') {
        if (this.customJob != '') {
          if (this.customLanguage != '') {
            if(this.unitPriceCurrentQ1>=0 && this.unitPriceCurrentQ2>=0 && this.unitPriceCurrentQ3>=0 && this.unitPriceCurrentQ4>=0
              && this.unitPriceFutureQ1>=0 && this.unitPriceFutureQ2>=0 && this.unitPriceFutureQ3>=0 && this.unitPriceFutureQ4>=0)
            {
            let updateArtwork: Artworkspecification[] = [];
            var updateDetail = {
              ID: this.customID,
              Active: this.customActive,
              Brand: updatebrand,
              Crop: this.customCrop,
              Job: this.customJob,
              Language: this.customLanguage,
              Specification: this.customSpecification,
              OpenSize: this.customOpenSize,
              FinishSize: this.customFinishSize,
              NoPage: this.customNoPages,
              Color: this.customColor,
              Fabrication: this.customFabrication,
              PrintingProcess: this.customPrinting,
              Remarks: this.customRemarks,
              unitPriceCurrentQ1:this.unitPriceCurrentQ1,
              unitPriceCurrentQ2:this.unitPriceCurrentQ2,
              unitPriceCurrentQ3:this.unitPriceCurrentQ3,
              unitPriceCurrentQ4:this.unitPriceCurrentQ4,
              unitPriceFutureQ1:this.unitPriceFutureQ1,
              unitPriceFutureQ2:this.unitPriceFutureQ2,
              unitPriceFutureQ3:this.unitPriceFutureQ3,
              unitPriceFutureQ4:this.unitPriceFutureQ4            
            };
            updateArtwork.push(updateDetail);
            this.artworksSpecificationService.updateArtworksSpecification(updateArtwork)
              .subscribe((resdata: any) => {
                if (resdata.status == true) {
                  this.getArtworksSpecification();
                  this.displayEditArtwork = 'none';
                  this.customID = 0;
                  this.customBrand = '';
                  this.customColor = '';
                  this.customCrop = '';
                  this.customFabrication = '';
                  this.customFinishSize = '';
                  this.customJob = '';
                  this.customLanguage = '';
                  this.customNoPages = '';
                  this.customOpenSize = '';
                  this.customPrinting = '';
                  this.customSpecification = '';
                  this.customRemarks = '';
                  this.unitPriceCurrent=0;
                  this.unitPriceFuture=0;
                  this.getArtworksSpecificationDropDown();
                  this.toastr.success(resdata.data[0].msg);
                  //this.toastr.error(resdata.data[0].msg, 'Close', 'green-snackbar');
                  this.loader = 'none';
                }
                else {
                  this.toastr.error(resdata.data[0].msg);
                  //this.toastr.error(resdata.data[0].msg, 'Close', 'red-snackbar');
                  this.loader = 'none';
                  this.displayEditArtwork = 'none';
                }
              })
            }
            else{
              this.toastr.error("Unit Price should be Non Negetive");
              //this.toastr.error("Unit Price should be Non Negetive", 'Close', 'red-snackbar');
              this.loader = 'none';
            }
          }
          else {
            this.toastr.error("Mandatory Fields can not be empty");
            //this.toastr.error("Mandatory Fields can not be empty", 'Close', 'red-snackbar');
            this.getArtworksSpecificationDropDown();
            this.loader = 'none';
          }
        }
        else {
          this.toastr.error("Mandatory Fields can not be empty");
         // this.toastr.error("Mandatory Fields can not be empty", 'Close', 'red-snackbar');
          this.getArtworksSpecificationDropDown();
          this.loader = 'none';
        }
      }
      else {
        this.toastr.error("Mandatory Fields can not be empty");
        //this.toastr.error("Mandatory Fields can not be empty", 'Close', 'red-snackbar');
        this.getArtworksSpecificationDropDown();
        this.loader = 'none';
      }
    }
    else {
      this.toastr.error("Mandatory Fields can not be empty");
      //this.toastr.error("Mandatory Fields can not be empty", 'Close', 'red-snackbar');
      this.getArtworksSpecificationDropDown();
      this.loader = 'none';
    }
  }

  getArtworksSpecificationDropDown() {
    this.loader = 'block';
    this.artworksSpecificationService.getArtworksSpecificationDropDown()
      .subscribe((resdata: any) => {
        if (resdata.status == true) {
          this.AddJobdropdown = resdata.data as DropDown;
          this.loader = 'none';
        }
        else {
          this.toastr.error(resdata.msg);
          //this.toastr.error(resdata.msg, 'Close', 'red-snackbar');
          this.loader = 'none';
        }
      })
  }

  otherBrand() {
    if (this.customBrand == 'Others') {
      this.displayOtherBrand = 'block';
      this.otherBrands = 'true';
    }
    else {
      this.displayOtherBrand = 'none';
      this.otherBrands = 'false';
    }
    this.customOtherBrand = '';
    this.customBrandManager = '';
  }
  closeOtherBrand() {
    this.displayEditArtwork = 'block';
    this.customOtherBrand = '';
    this.customOtherBrandId = '';
    this.customBrandManager = '';
    this.customItemName = '';
    this.otherBrands = 'false';
    this.displayOtherBrand = 'none';
  }

  addOtherBrand() {
    this.loader = 'block';
    if (this.customOtherBrand != '') {
      this.artworksSpecificationService.updateOtherBrands(this.customCrop, this.customOtherBrand, this.customBrandManager)
        .subscribe((resdata: any) => {
          if (resdata.status == true) {
            if (resdata.data[0].status == 'true') {
              this.getArtworksSpecificationDropDown();
              this.customLanguage = '';
              this.loader = 'none';
              this.displayOtherBrand = 'none';
              this.otherBrands = 'false';
              this.disabledOptions = false;
              this.displayEditArtwork = 'block';
              this.customBrand = this.customOtherBrand;
            }
            else {
              this.toastr.error(resdata.data[0].msg);
              //this.toastr.error(resdata.data[0].msg, 'Close', 'red-snackbar');
              this.loader = 'none';
            }
          }
          else {
            this.toastr.error(resdata.msg);
            this.loader = 'none';
          }
        })
    }
    else {
      this.toastr.error("Mandatory Fields can not be empty");
      this.loader = 'none';
      this.customOtherBrand = '';
      this.customItemName = '';
    }
  }

  selectEvent(item) {
    console.log(item);
    // do something with selected item
  }

  onChangeSearch(val: string) {
    console.log(val);
    this.customOtherBrand = '';
    this.customBrandManager = '';
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }

  onFocused(e) {
    console.log(e);
    // do something when input is focused
  }

  ViewUnitPricePanel()
  {
   this.displayEditPanel='block'; 
  }

  closeEditPanel()
  {
    this.displayEditPanel='none'; 
  }
}

